import React from 'react';
import PortableText from 'react-portable-text';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, useMediaQuery } from '@material-ui/core';

import { ListItem } from '../../CustomStyles/Typography';

const useStyles = makeStyles((theme) => ({
  text: {
    color: '#4B5B69',
    fontFamily: 'Roboto',
    fontSize: '1.25rem',
    paddingTop: '1em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.125rem',
    },
  },
  bulletCopy: {
    [theme.breakpoints.down('sm')]: {
      padding: '.5rem 0 0',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.125rem',
    },
  },
  linkText: {
    color: theme.mediumDarkGray,
  },
}));

export const FeatureBodyCopy = ({
  _rawBodyCopy,
  routing,
  qbLogo,
  qbLink,
  marketing,
}) => {
  const classes = useStyles();
  const med = useMediaQuery('(max-width: 960px)');
  return (
    <>
      <Grid
        item
        container
        direction='column'
        alignItems='flex-start'
        justifyContent='space-evenly'
      >
        {_rawBodyCopy.map((content, index) => (
          <PortableText
            key={index}
            content={content}
            // className={classes.text}
            serializers={{
              h2: ({ children }) => (
                <Typography
                  variant='h2'
                  style={{
                    lineHeight: 0.9,
                    color: routing && 'white',
                  }}
                >
                  {children}
                </Typography>
              ),
              normal: ({ children }) => (
                <Typography
                  variant='body1'
                  className={classes.text}
                  style={{
                    lineHeight: marketing && '32px',
                    color: routing && 'white',
                  }}
                >
                  {children}
                </Typography>
              ),
              li: ({ children }) => (
                <Grid item>
                  <ListItem>
                    <li className={classes.bulletCopy}>{children}</li>
                  </ListItem>
                </Grid>
              ),
              internalLink: ({ children, internalSlug }) => (
                <Link to={`/${internalSlug}`} className={classes.linkText}>
                  {children}
                </Link>
              ),
              link: (props) => {
                //console.log(props);
                return (
                  <a
                    className={classes.linkText}
                    href={props.href}
                    style={{ textDecoration: 'underline' }}
                    target='_blank'
                    rel='noreferrer'
                  >
                    {props.children[0]}
                  </a>
                );
              },
              h4: ({ children }) => (
                <Typography
                  variant='body1'
                  className={classes.text}
                  style={{
                    fontSize: '1rem',
                    marginLeft: '1rem',
                  }}
                >
                  {children}
                </Typography>
              ),
              code: ({ children }) => (
                <Typography
                  variant='body1'
                  className={classes.text}
                  style={{
                    fontSize: '.8rem',
                    marginLeft: '1rem',
                  }}
                >
                  {children}
                </Typography>
              ),
              strong: ({ children }) => (
                <span style={{ color: '#3FA529', fontWeight: 600 }}>
                  {children}
                </span>
              ),
            }}
          />
        ))}
      </Grid>
      {qbLink ? (
        <Grid container>
          <Grid item xs={12}>
            <a href={qbLink} target='_blank'>
              <GatsbyImage image={qbLogo?.node.appLogo.asset.gatsbyImageData} />
            </a>
          </Grid>
        </Grid>
      ) : null}
    </>
  );
};
